const BENCHMARK_DESIGN_MODE_TRUTHY = new Set(["true", "1", "yes", "enabled"]);
const BENCHMARK_DESIGN_MODE_FALSY = new Set(["false", "0", "no", "disabled"]);

export function parseBenchmarkDesignMode(raw: unknown): boolean {
  if (raw === undefined || raw === null || raw === "") {
    return false;
  }

  if (typeof raw !== "string") {
    return false;
  }

  const normalized = raw.trim().toLowerCase();

  if (BENCHMARK_DESIGN_MODE_TRUTHY.has(normalized)) {
    return true;
  }

  if (BENCHMARK_DESIGN_MODE_FALSY.has(normalized)) {
    return false;
  }

  throw new Error(
    `Invalid BENCHMARK_DESIGN_MODE value "${raw}". Use true/false, 1/0, yes/no, or enabled/disabled.`,
  );
}
